export const initMap = async () => {
  const mapElement = document.querySelector("#map")

  if (mapElement) {
    const { MapRenderer } = await import("./map.js")
    MapRenderer(mapElement)
  }
}
